<template>
  <div class="animated fadeIn">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-4"
        />
      </b-col>
    </b-row>
    <div v-else>
      <component-header
        title="Q&A Configuration"
        @create-press="createSurveyRoute"
        :hasback="true"
        :hasCreate="true"
        :hasSearch="true"
        :hasReload="true"
        :isLoading="loading"
        @reload-data="getSurveyList"
        @back-press="$router.push('./dashboard')"
      />
      <b-card class="card-wrap" border-variant="info">
        <div>
          <b-table
            style="border-radius: 12px"
            :dark="dark"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive
            class="tableRadius"
            :items="surveyList"
            :fields="surveyColumns"
            :per-page="perPage"
            :filter="filter"
            thead-class="header"
            show-empty
            :busy="loading"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="action" slot-scope="data">
              <div class="inline_btnTable">
                <b-button
                  size="sm"
                  class="button-circle mr-2"
                  variant="primary"
                  @click="editSurvey(data.item)"
                >
                  <i class="fa fa-pencil"></i>
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
export default {
  name: "surveylist",
  components: {
    AtomSpinner,
    ComponentHeader,
  },
  data() {
    return {
      filterCount: 0,
      loading: false,
      perPage: 100,
      currentPage: 1,
      filter: "",
      loading: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      context: "Add",
      sortBy: "createdAt",
      sortDesc: true,
      surveyColumns: [
        {
          key: "title",
          label: "Ttile",
          sortable: true,
        },
        {
          key: "description",
        },
        {
          key: "createdAt",
        },
        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      questionList: (state) => state.survey.questionList,
    }),
    surveyList() {
      return this.questionList.data?.map((question) => ({
        _id: question._id,
        title: question.title,
        description: question.description,
        createdAt: moment(question.createdAt).format("DD-MM-YYYY HH:mm:ss"),
      }));
    },
  },
  methods: {
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    createSurveyRoute() {
      this.$router.push({ name: "Create Q&A" });
    },
    editSurvey(item) {
      this.$router.push({
        name: "Edit Q&A",
        params: { surveyId: item._id },
      });
    },
    async getSurveyData(e) {
      this.currentPage = e;
      await this.getSurveyList();
    },
    async getSurveyList() {
      this.loading = true;
      await this.$store
        .dispatch("survey/fetchQuestionSet")
        .then((data) => {
          if (data.message) {
            this.$toasted.error(data.message);
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  async mounted() {
    this.getSurveyList();
  },
};
</script>

<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
